import { ComponentChildren } from 'preact';
import { classNames } from '../utils/UNSAFE_classNames';
import { cssProps } from '@oracle/oraclejet-cssprops';
import { UserAssistanceDensityType } from './InlineUserAssistance';

const baseStyles = cssProps`${{
  marginTop: '2px',
  color: 'var(--oj-c-PRIVATE-DO-NOT-USE-user-assistance-inline-text-color)',
  fontSize: 'var(--oj-c-PRIVATE-DO-NOT-USE-user-assistance-inline-font-size)',
  fontWeight: 'normal',
  lineHeight: 1.333,
  wordBreak: 'break-word'
}}`;
const variantStyles = {
  reflow: cssProps`${{
    '&:empty': {
      marginTop: '0px'
    }
  }}`,
  efficient: cssProps`${{
    minHeight: '1.333rem'
  }}`
};

type Props = {
  children?: ComponentChildren;
  id?: string;
  variant?: UserAssistanceDensityType;
};

// defaults to type='reflow'. If this is within an oj-form-layout, the o-f-l
// will pass down its type which defaults to 'efficient' (TODO).
export function InlineUserAssistanceContainer({ variant = 'reflow', children, id }: Props) {
  const classes = classNames([baseStyles, variantStyles[variant]]);

  return (
    <div class={classes} id={id}>
      {children}
    </div>
  );
}
